import { forwardRef } from 'react';
import { theme } from '@frontend/theme';
import { ListRow, ListRowProps } from '@frontend/design-system';

type ListButtonProps = Omit<ListRowProps<'button'>, 'as' | 'type'>;

const ListButtonComponent = forwardRef<HTMLButtonElement, ListButtonProps>(({ children, ...props }, ref) => (
  <ListRow
    as='button'
    css={{
      alignItems: 'center',
      background: theme.colors.white,
      borderRadius: theme.borderRadius.small,
      border: 'solid 1px transparent',
      boxShadow: theme.shadows.light,
      cursor: 'pointer',
      fontSize: 'initial',
      padding: theme.spacing(1, 2),
      textAlign: 'left',
      transition: 'all 150ms ease',

      '&:hover, &:focus': {
        background: theme.colors.neutral5,
        boxShadow: theme.shadows.floating,
        outline: 'none',
      },
    }}
    ref={ref}
    type='button'
    {...props}
  >
    {children}
  </ListRow>
));

ListButtonComponent.displayName = 'ListButton';

export const ListButton = Object.assign(ListButtonComponent, {
  Content: ListRow.Content,
  Lead: ListRow.Lead,
  Trail: ListRow.Trail,
});
